//#region frontend/entrypoints/predictive-search.js
var PredictiveSearch = class extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input[type=\"search\"]");
		this.predictiveSearchResults = document.querySelector("#predictive-search");
		this.input.addEventListener("input", this.debounce((event) => {
			this.onChange(event);
		}, 300).bind(this));
	}
	onChange() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			return;
		}
		this.getSearchResults(searchTerm);
	}
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search-results`).then((response) => {
			if (!response.ok) {
				var error = new Error(response.status);
				this.close();
				throw error;
			}
			return response.text();
		}).then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search-results").innerHTML;
			this.predictiveSearchResults.innerHTML = resultsMarkup;
			this.open();
		}).catch((error) => {
			this.close();
			throw error;
		});
	}
	open() {
		this.predictiveSearchResults.style.display = "block";
	}
	close() {
		this.predictiveSearchResults.style.display = "none";
	}
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
};
customElements.define("predictive-search", PredictiveSearch);
//#endregion
